<template>
  <div class="download-page">
    <Navbar :entName="entName" :logo="logo" />

    <!-- Banner -->
    <section class="page-banner">
      <div class="container">
        <h1>资料下载</h1>
        <p>为您提供丰富的产品资料与技术文档</p>
      </div>
    </section>

    <!-- 下载列表 -->
    <section class="download-content">
      <div class="container">
        <div v-if="loading" class="loading-tip">加载中...</div>
        <div v-else-if="list.length === 0" class="empty-tip">暂无资料</div>
        <div v-else class="download-list">
          <div
            v-for="item in list"
            :key="item.id"
            class="download-item"
          >
            <div class="file-icon">
              <i :class="getIconClass(item.fileName)"></i>
            </div>
            <div class="file-info">
              <h3 class="file-title">{{ item.title }}</h3>
              <div class="file-meta">
                <span v-if="item.fileName">原文件名：{{ item.fileName }}</span>
                <span v-if="item.fileSize">· {{ formatSize(item.fileSize) }}</span>
                <span v-if="item.createTime">· {{ formatDate(item.createTime) }}</span>
              </div>
            </div>
            <div class="file-action">
              <a
                :href="getFileUrl(item.filePath)"
                target="_blank"
                class="btn-download"
              >
                <i class="fa fa-download"></i>
                下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import config from "@/config";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "Download",
  components: { Navbar, Footer },
  mixins: [pageDataMixin],
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      api
        .get("/api/download/getList")
        .then((response) => {
          if (response.data && response.data.code === 0) {
            this.list = response.data.data || [];
          }
        })
        .catch(() => {
          // 静默处理
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFileUrl(path) {
      if (!path) return "#";
      // 如果已经是完整 URL，直接返回
      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }
      let base = config.apiBaseUrl || "";
      base = base.replace(/\/$/, "");
      return base + path;
    },
    getIconClass(fileName) {
      if (!fileName) return "fa fa-file";
      const ext = fileName.split(".").pop().toLowerCase();
      const map = {
        pdf: "fa fa-file",
        doc: "fa fa-file",
        docx: "fa fa-file",
        xls: "fa fa-table",
        xlsx: "fa fa-table",
        ppt: "fa fa-file-powerpoint-o",
        pptx: "fa fa-file-powerpoint-o",
        zip: "fa fa-file-archive-o",
        rar: "fa fa-file-archive-o",
        txt: "fa fa-file-text-o",
      };
      return map[ext] || "fa fa-file";
    },
    formatSize(bytes) {
      if (!bytes) return "";
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / 1024 / 1024).toFixed(2) + " MB";
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return dateStr.substring(0, 10);
    },
  },
};
</script>

<style scoped>
.download-page {
  font-family: Arial, sans-serif;
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* Banner */
.page-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.page-banner h1 {
  font-size: 2.5rem;
  margin: 0 0 0.5rem 0;
}

.page-banner p {
  font-size: 1.1rem;
  margin: 0;
  opacity: 0.9;
}

/* 下载列表 */
.download-content {
  padding: 3rem 0;
}

.loading-tip,
.empty-tip {
  text-align: center;
  padding: 3rem 0;
  color: #999;
  font-size: 1rem;
}

.download-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.download-item {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.25rem 1.5rem;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.download-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: #667eea;
}

.file-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  flex-shrink: 0;
}

.file-info {
  flex: 1;
  min-width: 0;
}

.file-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.4rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta {
  font-size: 0.85rem;
  color: #888;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.file-action {
  flex-shrink: 0;
}

.btn-download {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.55rem 1.2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: opacity 0.3s ease;
}

.btn-download:hover {
  opacity: 0.9;
  color: white;
  text-decoration: none;
}

@media (max-width: 768px) {
  .download-item {
    flex-wrap: wrap;
  }
  .file-action {
    width: 100%;
    text-align: center;
    margin-top: 0.8rem;
  }
  .page-banner h1 {
    font-size: 1.8rem;
  }
}
</style>

